const leezenApplications = [
    {
        "uuid": "1",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A18080101",
        "appType": "initial",
        "projectManager": "陳阿鼠",
        "appStayDays": 2,
        "appProgress": "close",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.3",
                        "ncrType":"secondary",
                        "result":"N",
                        "observation":"沒有持續全程在場"
                    },
                    {
                        "itemCode":"1.4",
                        "ncrType":"observation",
                        "result":"N",
                        "observation":"標籤微破損"
                    },
                    {
                        "itemCode":"1.5",
                        "result":"Y"
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "ncrType":"secondary",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.10"
                    }
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.17",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.18",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.19",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "ncrs": [
            {
                "carNo": "INS001-01",
                "ncrType": "primary",
                "observationDesc": "廠外環境污染源現況與申請資料描述不一致",
                "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-02",
                "ncrType": "secondary",
                "observationDesc": "客戶提供之評鑑場所平面圖與實際看到者不一致",
                "correctionActionPlan": "施工調整",
                "evaluateCorrectiveAction": "improve",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-03",
                "ncrType": "secondary",
                "observationDesc": "原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "correctionActionPlan": "使用系統控管原料相關文件",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "track",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-04",
                "ncrType": "secondary",
                "observationDesc": "原材料進貨時沒有驗收紀錄",
                "correctionActionPlan": "",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "correct",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
        ],
    },
    {
        "uuid": "2",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A19010101",
        "appType": "followUp",
        "projectManager": "李阿虎",
        "appStayDays": 4,
        "appProgress": "close",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.3",
                        "ncrType":"secondary",
                        "result":"N",
                        "observation":"沒有持續全程在場"
                    },
                    {
                        "itemCode":"1.4",
                        "ncrType":"observation",
                        "result":"N",
                        "observation":"標籤微破損"
                    },
                    {
                        "itemCode":"1.5",
                        "result":"Y"
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "ncrType":"secondary",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.10"
                    }
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.17",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.18",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.19",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "ncrs": [
            {
                "carNo": "INS001-01",
                "ncrType": "primary",
                "observationDesc": "廠外環境污染源現況與申請資料描述不一致",
                "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-02",
                "ncrType": "secondary",
                "observationDesc": "客戶提供之評鑑場所平面圖與實際看到者不一致",
                "correctionActionPlan": "施工調整",
                "evaluateCorrectiveAction": "improve",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-03",
                "ncrType": "secondary",
                "observationDesc": "原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "correctionActionPlan": "使用系統控管原料相關文件",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "track",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-04",
                "ncrType": "secondary",
                "observationDesc": "原材料進貨時沒有驗收紀錄",
                "correctionActionPlan": "",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "correct",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
        ],
    },
    {
        "uuid": "3",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A20010101",
        "appType": "followUp",
        "projectManager": "白阿龍",
        "appStayDays": 8,
        "appProgress": "close",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.3",
                        "ncrType":"secondary",
                        "result":"N",
                        "observation":"沒有持續全程在場"
                    },
                    {
                        "itemCode":"1.4",
                        "ncrType":"observation",
                        "result":"N",
                        "observation":"標籤微破損"
                    },
                    {
                        "itemCode":"1.5",
                        "result":"Y"
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "ncrType":"secondary",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.10"
                    }
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.17",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.18",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.19",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "ncrs": [
            {
                "carNo": "INS001-01",
                "ncrType": "primary",
                "observationDesc": "廠外環境污染源現況與申請資料描述不一致",
                "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-02",
                "ncrType": "secondary",
                "observationDesc": "客戶提供之評鑑場所平面圖與實際看到者不一致",
                "correctionActionPlan": "施工調整",
                "evaluateCorrectiveAction": "improve",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-03",
                "ncrType": "secondary",
                "observationDesc": "原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "correctionActionPlan": "使用系統控管原料相關文件",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "track",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-04",
                "ncrType": "secondary",
                "observationDesc": "原材料進貨時沒有驗收紀錄",
                "correctionActionPlan": "",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "correct",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
        ],
    },
    {
        "uuid": "4",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A21010101",
        "appType": "renewal",
        "phase": "inspectionArrangement",
        "activity": "inspectionArrangement_S10",
        "projectManager": "馬阿馬",
        "handler": "蔡阿羊",
        "appStayDays": 16,
        "appProgress": "normal",
        "confirmStatement": true,
        "productionLineRemoves": [
            {
                "productionLine": "果汁線",
                "removes":[
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "approve",
                        "agree": true,
                    },
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "improvement",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "suspend",
                        "agree": true,
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
            {
                "productionLine": "飲料線",
                "removes":[
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "360ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                        "agree": true,
                    },
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "1000ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
            {
                "productionLine": "餅乾線",
                "removes":[
                    {
                        "name": "杏仁玄米餅",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "餅乾線",
                        "processStatus": "backEnd",
                        "packaging": "paperBag",
                        "spec": "200/盒",
                        "channel": ["leezen"],
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
        ],
        "productAttachmentOverdueList": [
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "reviewResult": "qualified",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "reviewResult": "unQualified",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2021-12-20T08:00:00.000Z",
                "reviewResult": "noNeedToTrack",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-10-30T08:00:00.000Z",
                "reviewResult": "qualified",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "alcoholContentTestReport",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2022-01-09T08:00:00.000Z",
                "reviewResult": "qualified",
            },
            {
                "product": "桂圓四物飲",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案51.pdf",
                "validDateOld": "2021-12-05T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2022-01-05T08:00:00.000Z",
                "reviewResult": "qualified",
            },
        ],
        "rawMaterialAttachmentOverdueList": [
            {
                "rawMaterial": "豆蓉粉",
                "product": "杏仁玄米餅",
                "attachmentType": "inspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "composition":"",
                "domesticVendor":"穎昌食品有限公司(新和美)",
                "importer":"",
                "manufacturer":"穎昌食品有限公司(新和美)",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "addRatio":9,
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":1,
                "relatedDocuments":[
                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                ],
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                    },
                ]
            },
            {
                "rawMaterial": "美國加州杏仁果",
                "product": "杏仁玄米餅、杏仁巧克力酥",
                "attachmentType": "foodAdditiveLicense",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "有效日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "domesticVendor":"信成股份有限公司",
                "importer":"信成股份有限公司",
                "manufacturer":"TERRA NOVA TRADING INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":2,
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "有機生糙米粉(台灣)",
                "product": "杏仁巧克力酥",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "進口日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"青田農產有限公司",
                "importer":"",
                "manufacturer":"青田農產有限公司",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":8,
                "validDateNew": "2022-01-20T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "甜扁桃仁粒",
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"TWIN COMMODITIES,INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":6,
                "validDateNew": "2021-11-30T08:00:00.000Z",
                "description": "說明......",
                "disable": true,
                "agree": true,
            },
            {
                "rawMaterial": "杏仁粉(細)",
                "product": "杏仁玄米餅",
                "attachmentType": "organicCertificate",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"roomTemperature",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"Treehouse California Almonds LLC",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":11,
                "validDateNew": "2022-02-09T08:00:00.000Z",
                "description": "說明......",
            },
        ],
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"1.3",
                        "ncrType":"secondary",
                        "result":"N",
                        "observation":"沒有持續全程在場"
                    },
                    {
                        "itemCode":"1.4",
                        "ncrType":"observation",
                        "result":"N",
                        "observation":"標籤微破損"
                    },
                    {
                        "itemCode":"1.5",
                        "result":"Y"
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "ncrType":"secondary",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"5.10"
                    }
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.17",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.18",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.19",
                        "result":"Y"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.3",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.5",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.14",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.15",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.16",
                        "result":"Y"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "ncrs": [
            {
                "carNo": "INS001-01",
                "ncrType": "primary",
                "observationDesc": "廠外環境污染源現況與申請資料描述不一致",
                "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-02",
                "ncrType": "secondary",
                "observationDesc": "客戶提供之評鑑場所平面圖與實際看到者不一致",
                "correctionActionPlan": "施工調整",
                "evaluateCorrectiveAction": "improve",
                "reviewResult": "accept",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-03",
                "ncrType": "secondary",
                "observationDesc": "原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "correctionActionPlan": "使用系統控管原料相關文件",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "track",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
            {
                "carNo": "INS001-04",
                "ncrType": "secondary",
                "observationDesc": "原材料進貨時沒有驗收紀錄",
                "correctionActionPlan": "",
                "evaluateCorrectiveAction": "agree",
                "reviewResult": "correct",
                "estimatedImprovementDate": "2021-12-24T00:00:00.000Z",
                "evaluateContent": "稽核員矯正評估......",
                "reviewComments": "審查彙總的不符合之意見......",
            },
        ],
    },
    {
        "uuid": "5",
        "appNo": "21112001",
        "appType": "independentSampling",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "status": "open",
        "phase": "independentSampling",
        "activity": "independentSampling_S40",
        "projectManager": "張阿猴",
        "handler": "葉阿雞",
        "appStayDays": 32,
        "appProgress": "normal",
        "assignee": "陳小黑",
        "createdOn": "2021-11-10T08:20:10.000Z",
        "creator": "王小白",
        "organizerSampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectorSampleInfos": [
            {
                "product":"02",
                "testType":"finishedGood",
                "testName":"Pasta義大利麵",
                "finishedGoodTestName":"Pasta義大利麵",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"05",
                "testType":"rawMaterial",
                "testName":"Natural Benefits 純在-蔬菜綜合果汁",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectors": [
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "李大白"},
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "王阿天"},
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "陳小藍"},
        ]
    },
    {
        "uuid": "6",
        "appNo": "21111922",
        "appType": "independentSampling",
        "customerNo": "0003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "台南廠",
        "status": "close",
        "projectManager": "詹阿狗",
        "appStayDays": 16,
        "appProgress": "close",
        "createdOn": "2021-11-12T08:20:10.000Z",
        "creator": "張小華",
        "organizerSampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectorSampleInfos": [
            {
                "product":"02",
                "testType":"finishedGood",
                "testName":"Pasta義大利麵",
                "finishedGoodTestName":"Pasta義大利麵",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"05",
                "testType":"rawMaterial",
                "testName":"Natural Benefits 純在-蔬菜綜合果汁",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "inspectors": [
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "李大白"},
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "王阿天"},
            {"samplingDate": "2021-09-13T08:20:10.000Z", "inspector": "陳小藍"},
        ]
    },
    {
        "uuid": "7",
        "appNo": "21080101",
        "appType": "markReview",
        "phase": "markReview",
        "activity": "markReview_S10",
        "customerNo": "0001",
        "customerName": "中農粉絲有限公司",
        "projectManager": "李阿白",
        "handler": "陳阿明",
        "appStayDays": 8,
        "appProgress": "normal",
        "assignee": "王大大",
        "reviewResult": "",
        "applicationDate": "2021-12-17T22:15:00.000Z",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "assessmentPlaceList": [
            {
                "name": "台東廠",
                "address": "11501 台北市南港區三重路19-11號",
                "phone": "02-7723-8001",
            },
            {
                "name": "屏東廠",
                "address": "屏東縣恆春鎮海角路7號",
                "phone": "02-8787-5566",
            },
        ],
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 食安生技-椰子汁", "agree":true},
                    {"item": "content", "information": "請參考原料說明", "agree":true},
                    {"item": "spec", "information": "360ml/罐", "agree":true},
                    {"item": "customerName", "information": "源天然股份有限公司", "agree":true},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號", "agree":true},
                    {"item": "phone", "information": "089-360960", "agree":true},
                    {"item": "markLevel", "information": "潔淨", "agree":true},
                    {"item": "otherAppeals", "information": "", "agree":true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 純在-蔬菜綜合果汁", "agree":true},
                    {"item": "content", "information": "請參考原料說明", "agree":true},
                    {"item": "spec", "information": "360ml/罐", "agree":true},
                    {"item": "customerName", "information": "源天然股份有限公司", "agree":true},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號", "agree":true},
                    {"item": "phone", "information": "089-360960", "agree":true},
                    {"item": "markLevel", "information": "潔淨", "agree":true},
                    {"item": "otherAppeals", "information": "", "agree":true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
            },
        ],
    },
    {
        "uuid": "8",
        "createdOn": "2021-12-17T22:15:00.000Z",
        "appNo": "21080102",
        "appType": "markReview",
        "phase": "markReview",
        "activity": "markReview_S20",
        "customerNo": "0002",
        "customerName": "黑松股份有限公司",
        "projectManager": "張阿偉",
        "handler": "蔡阿豪",
        "appStayDays": 4,
        "appProgress": "normal",
        "assignee": "李小小",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "assessmentPlaceList": [
            {
                "name": "台東廠",
                "address": "11501 台北市南港區三重路19-11號",
                "phone": "02-7723-8001",
            },
            {
                "name": "屏東廠",
                "address": "屏東縣恆春鎮海角路7號",
                "phone": "02-8787-5566",
            },
        ],
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 食安生技-椰子汁", "agree":true},
                    {"item": "content", "information": "請參考原料說明", "agree":true},
                    {"item": "spec", "information": "360ml/罐", "agree":true},
                    {"item": "customerName", "information": "源天然股份有限公司", "agree":true},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號", "agree":true},
                    {"item": "phone", "information": "089-360960", "agree":true},
                    {"item": "markLevel", "information": "潔淨", "agree":true},
                    {"item": "otherAppeals", "information": "", "agree":true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 純在-蔬菜綜合果汁", "agree":true},
                    {"item": "content", "information": "請參考原料說明", "agree":true},
                    {"item": "spec", "information": "360ml/罐", "agree":true},
                    {"item": "customerName", "information": "源天然股份有限公司", "agree":true},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號", "agree":true},
                    {"item": "phone", "information": "089-360960", "agree":true},
                    {"item": "markLevel", "information": "潔淨", "agree":true},
                    {"item": "otherAppeals", "information": "", "agree":true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
            },
        ],
    },
]

export default leezenApplications;